module.exports = __webpack_public_path__ + "img/Moldova.32adbb31.gif";